import { render } from "./LinkedInPosts.vue?vue&type=template&id=2ee45c35"
import script from "./LinkedInPosts.vue?vue&type=script&lang=js"
export * from "./LinkedInPosts.vue?vue&type=script&lang=js"

import "./LinkedInPosts.vue?vue&type=style&index=0&id=2ee45c35&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__